<template>
    <div v-loading="loading">
        <div v-if="showModel == 'brand'">
            <div class="search-btn-list">
                <div class="tab-list">
                    <span :class="{ check: checkId === item }" v-for="(item, index) in tabOptions" :key="item"
                        @click="changeTab(item, index)">{{ item }}</span>
                </div>
                <div class="vin-zone">
                    <el-select v-model="searchMode" placeholder="请选择" size="small">
                        <el-option key="0" label="VIN码" value="0"></el-option>
                        <el-option key="1" label="车型名称" value="1"></el-option>
                        <!-- <el-option key="2" label="零件号" value="2"></el-option> -->
                    </el-select>
                    <el-input size="small" clearable v-model.trim="content" v-filter-special-char="content"
                        placeholder="请输入查询内容"></el-input>
                    <el-button icon="el-icon-search" class="btn-primary" size="small" @click="handleSearch">查询</el-button>
                </div>
            </div>
            <div class="dialog-s-content">
                <div v-for="(item, index) in seriesList" v-bind:key="index" class="brand">
                    <div class="brand-img">
                        <img :src="downloadUrl + item.Logo" alt="" />
                        <span>{{ item.MainBrandName }}</span>
                    </div>
                    <div class="brand-zone">
                        <div v-for="(secBrand, index) in item.SecBrandList" v-bind:key="index">
                            <div class="sec-brand">{{ secBrand.AMBrandName }}</div>
                            <div class="series">
                                <div class="item" v-for="(series, index) in secBrand.SeriesList" v-bind:key="index"
                                    @click="getAutoSeries(series.AMSeriesId)">
                                    <div class="sname">
                                        {{ series.AMSeriesName }} <span class="cate">{{ series.VehCate }}</span>
                                    </div>
                                    <div class="scount">车型总数： {{ series.VehNum }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showModel == 'series'">
            <div class="series-btn-list">
                <div class="back-zone">
                    <el-button size="small" icon="el-icon-back" class="back-btn btn-primary"
                        @click="backToBrand">返回</el-button>
                </div>
                <div class="tab-list">
                    <span :class="{ check: yearCheck === item }" v-for="(item, index) in yearOptions" :key="item"
                        @click="changeYearTab(item, index)">{{ item }}</span>
                </div>
            </div>
            <div class="dialog-s-content">
                <div class="veh-table-ctn" v-for="(item, index) in vehiclesList" :key="index">
                    <el-table :header-cell-style="{ background: '#F2F6FC' }" @row-click="rowClick" :data="item.VehiclesList"
                        style="width: 100%">
                        <el-table-column prop="AMVehicleName">
                            <template slot="header">
                                <span class="c-hear">{{ item.Hearder }}</span>
                            </template>
                            <template slot-scope="scope">
                                {{ scope.row.AMVehicleName }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="AMBrandName" show-overflow-tooltip width="130" label="品牌"></el-table-column>
                        <el-table-column prop="AMSeriesName" show-overflow-tooltip width="130" label="车系"></el-table-column>
                        <el-table-column prop="DrivenType" show-overflow-tooltip width="130" label="驱动形式"></el-table-column>
                        <el-table-column prop="EngineModel" show-overflow-tooltip width="150" label="发动机"></el-table-column>
                        <el-table-column prop="EffluentStandard" show-overflow-tooltip width="100" label="排放标准">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <!-- <el-dialog :title="epcTitle" :close-on-click-modal="false" :visible.sync="epcVisible" :close-on-press-escape="false"
            append-to-body width="1350px">
            <div class="dialog-content" v-if="epcVisible">
                <Epc ref="Epc" :visible="epcVisible" :vehicleId="vehId" />
            </div>
        </el-dialog> -->
        <el-dialog
            :title="epcTitle"
            :close-on-click-modal="false"
            :visible.sync="epcVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="epc-veh-dialog"
            style="margin-left: -600px"
            width="1350px"
        >
            <div v-if="epcVisible">
                <Epc ref="Epc" :visible="epcVisible" :vehicleId="vehId" />
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Epc from '@/components/business/goods/vinEPCDatas';
export default {
    mixins: [],
    components: {
        Epc
    },
    props: {},
    data() {
        return {
            downloadUrl: this.$util.QN_URL_BASE,
            content: '',
            checkId: '',
            tabOptions: [],
            dataList: [],
            seriesList: [],
            loading: false,
            showModel: 'brand',
            yearCheck: '',
            yearOptions: [],
            vehDataList: [],
            vehiclesList: [],
            vehId: '',
            epcVisible: false,
            unLimitDatas: [],
            epcTitle: '',
            searchMode: '0'
        };
    },
    mounted() {
        this.getTabOptions();
    },
    methods: {
        // 切换列表
        changeTab(val, index) {
            this.checkId = val;
            let list = Object.values(this.dataList);
            if (list.length > 0) this.seriesList = list[index];
        },
        changeYearTab(val, index) {
            this.vehiclesList = [];
            this.yearCheck = val;
            if (index == 0) {
                this.vehiclesList = this.unLimitDatas;
            } else {
                let list = Object.values(this.vehDataList);
                if (list.length > 0) {
                    let vehicles = list[index - 1];
                    if (vehicles && vehicles.length > 0) {
                        for (let j = 0; j < vehicles.length; j++) {
                            this.vehiclesList.push(vehicles[j]);
                        }
                    }
                }
            }
        },
        // 获取销售车型
        getAutoSeries(seriesId) {
            let that = this;
            if (seriesId) {
                //先恢复初始化状态
                that.yearOptions = [];
                that.vehiclesList = [];
                that.vehDataList = [];
                that.unLimitDatas = [];

                that.showModel = 'series';
                that.loading = true;
                that.$util
                    .axiosGet({
                        url: `/api/Auto/GetJYVehiclesList`,
                        data: { seriesId: seriesId },
                        hideLoading: true
                    })
                    .then(res => {
                        if (res.data) {
                            let data = res.data;
                            that.yearOptions = Object.keys(res.data);
                            that.yearOptions.unshift('不限');
                            that.yearCheck = that.yearOptions[0];
                            let list = Object.values(res.data);
                            if (list.length > 0) {
                                //第一次获取展示的就是不限的
                                for (let i = 0; i < list.length; i++) {
                                    let vehicles = list[i];
                                    if (vehicles && vehicles.length > 0) {
                                        for (let j = 0; j < vehicles.length; j++) {
                                            that.vehiclesList.push(vehicles[j]);
                                        }
                                    }
                                }
                                that.unLimitDatas = that.vehiclesList;
                                that.vehDataList = data;
                            }
                        }
                    })
                    .catch(() => { })
                    .finally(() => {
                        that.loading = false;
                    });
            }
        },
        // 获取字母列表
        getTabOptions() {
            this.loading = true;
            this.$util
                .axiosGet({
                    url: `/api/Auto/GetEntpAutoBrands`,
                    hideLoading: true
                })
                .then(res => {
                    if (res.data) {
                        this.dataList = res.data;
                        this.tabOptions = Object.keys(res.data);
                        if (this.tabOptions.length > 0) this.checkId = this.tabOptions[0];
                        let list = Object.values(res.data);
                        if (list.length > 0) this.seriesList = list[0];
                        else {
                            this.dataList = [];
                            this.tabOptions = [];
                            this.seriesList = [];
                        }
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            let that = this;
            that.loading = true;
            that.$util
                .axiosGet({
                    url: `/api/Auto/GetAutoDatasByKey`,
                    data: { content: that.content, searchMode: that.searchMode },
                    hideLoading: true
                })
                .then(res => {
                    that.yearOptions = [];
                    that.vehiclesList = [];
                    that.vehDataList = [];
                    that.unLimitDatas = [];
                    if (res.data) {
                        let data = res.data;
                        that.yearOptions = Object.keys(res.data);
                        that.yearOptions.unshift('不限');
                        that.yearCheck = that.yearOptions[0];
                        let list = Object.values(res.data);
                        if (list.length > 0) {
                            //第一次获取展示的就是不限的
                            for (let i = 0; i < list.length; i++) {
                                let vehicles = list[i];
                                if (vehicles && vehicles.length > 0) {
                                    for (let j = 0; j < vehicles.length; j++) {
                                        that.vehiclesList.push(vehicles[j]);
                                    }
                                }
                            }
                            that.unLimitDatas = that.vehiclesList;
                            that.vehDataList = data;
                        }
                    }
                    that.showModel = 'series';
                })
                .catch(() => { })
                .finally(() => {
                    that.loading = false;
                });
        },
        backToBrand() {
            this.showModel = 'brand';
        },
        rowClick(row) {
            if (row) {
                this.vehId = row.AMVehicleId;
                this.epcVisible = true;
                this.epcTitle = '【' + row.AMSeriesName + ' ' + row.AMVehicleName + '】装配图选配件';
            }
        }
    }
};
</script>
<style lang="less" scoped>
.c-hear {
    font-weight: 600;
}

.series-btn-list {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .back-zone {
        margin-right: 10px;
    }
}

.vin-zone {
    display: flex;
    flex-direction: row;
    margin-top: 5px;
    margin-bottom: 5px;

    .el-input {
        width: 180px;
    }

    .el-select {
        width: 90px;
    }
}

.search-btn-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.tab-list {
    display: flex;

    span {
        min-width: 25px;
        padding: 5px;
        margin: 5px;
        font-size: 14px;
        font-weight: 600;
        text-align: center;
        border-radius: 2px;
        cursor: pointer;
    }

    .check {
        color: #fff;
        background-color: #5bbeff;
    }
}

.dialog-s-content {
    height: 600px;
    overflow-y: auto;

    .brand {
        display: flex;
        flex-direction: row;
        border-top: 1px solid rgb(216, 213, 213);
        width: 1260px;
    }

    .brand:last-child {
        border-bottom: 1px solid rgb(216, 213, 213);
    }

    .brand-img {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 160px;
        padding: 20px;
        font-size: 20px;
        font-weight: 600;
        border-right: 1px solid rgb(216, 213, 213);

        img {
            height: 50px;
            width: 50px;
            margin-bottom: 15px;
        }
    }

    .brand-zone {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        width: 100%;

        .sec-brand {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            font-size: 18px;
            padding-left: 20px;
            background-color: #f5f5f5;
            width: 100%;
            height: 40px;
            border-bottom: 1px solid rgb(216, 213, 213);
        }

        .series {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;

            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                padding: 20px;
                height: 100%;
                width: 180px;

                .sname {
                    font-size: 16px;
                    font-weight: 550;

                    .cate {
                        font-size: 12px;
                        font-weight: 500;
                        margin-left: 5px;
                    }
                }
            }
        }
    }
}
#epc-veh-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;

    .el-dialog {
        box-shadow: 0 0 9px 3px #999;
    }

    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
<style lang="less">
.veh-table-ctn {
    .el-table {
        .el-table__body {
            .el-table__row {
                .cell {
                    button {
                        padding: 0;
                    }
                }

                td {
                    padding: 6px 0 !important;
                }
            }
        }

        th {
            padding: 6px 0 !important;
        }

        .el-table__footer-wrapper {
            .el-table__footer td {
                padding: 4px 0 4px 0;
            }
        }
    }
}
</style>
